const Aox = (props) => props.children;
export default Aox;